module.exports = __webpack_public_path__ + "img/BOLOGNA.dc9af18f.png";